<template>
    <div id="app" :style="config ? { '--global-background-color': config.background_color, '--icon-color': config.font_color  } : {}">
      <Window />
      <link rel="stylesheet" href="https://unpkg.com/vue-tel-input/dist/vue-tel-input.css" />
    </div>
  </template>

  <script>
  import store from './store';
  import Vue from 'vue'
  import VueConfirmDialog from 'vue-confirm-dialog'
  import Multiselect from 'vue-multiselect'
  import VueTelInput from 'vue-tel-input';
  import device from 'vue-device-detector-js'
  import GetTextPlugin from "vue-gettext";
  import translations from './translations/translations.json'
  import Window from "@/components/Window.vue";
  import {mapGetters, mapMutations, mapState} from "vuex";

  // register globally
  Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
  Vue.component('multiselect', Multiselect)
  Vue.use(VueConfirmDialog)
  Vue.use(VueTelInput);
  Vue.use(device);

  Vue.directive('prevent-parent-scroll', {
    bind(el) {
      const handler = (event) => {
        if (el.scrollTop === 0  && event.deltaY < 0 ||
            Math.abs(el.scrollTop - (el.scrollHeight - el.clientHeight)) <= 1 &&
            event.deltaY > 0)
        {
          event.preventDefault()
        }
      }
      el.addEventListener('wheel', handler)
    }
  })
  
  
  Vue.config.productionTip = false
  Vue.use(GetTextPlugin, {
    availableLanguages: {
      en: 'English',
      es: 'Spanish'
    },
    defaultLanguage: 'es',
    languageVmMixin: {
      methods: {
        merge(locale) {
          Object.assign(translations, locale);
        },
      }
    },
    translations: translations,
    silent: true
  })

  // Check if the app is running inside an iframe
  // The chat should not run inside an iframe
  let isOnIframe = window.self !== window.top;

  export default {
    components: !isOnIframe ? {Window} : {},
    store,
    name: 'App',
    props: {
      policy_url: {
        type: String,
        default: '/'
      },
      data_protection_url: {
        type: String,
        default: '/'
      },
      hide_incident_interactions: {
        type: Boolean,
        default: false
      },
      bounce_duration: {
        type: Number,
        default: store.state.bounce_duration
      },
      start_bounce: {
        type: Number,
        default: store.state.bounce_start || 0
      },
      web: {
        type: String,
        default: ''
      },
      groups: {
        type: String,
        default: '7,8,10,11,12,19'
      },
      phone_prefix: {
        type: String,
        default: "",
      },
      pulsecx_url: {
        type: String,
        default: ""
      }
    },
    data: function () {
      return {
        info_refreshed: false,
        localStartBounce: this.start_bounce
      };
    },
    mounted: function () {
      store.commit('setPolicyUrl', this.policy_url);
      store.commit("setDataProtectionUrl", this.data_protection_url);
      store.commit('setLocale', document.documentElement.lang);
      store.commit('setHideIncidentInteractions', this.hide_incident_interactions);
      store.commit('setPhonePrefix', this.phone_prefix);
      store.commit('setPulseCXUrl', this.pulsecx_url);
      if (this.isChatOpened) {
        this.refreshInformation();
      }
      store.http.startThreadRefresh();
      this.setBounceTimming();
      if (!this.has_bounced) {
        this.toggleBounce();
      }
    },
    methods: {
      ...mapMutations(['changeBounce', "changeHasBounced", 'setBounceDuration', 'setBounceStart', 'setQueuePosition']),
      toggleBounce: function (withoutDelay) {
        if (!this.$store.state.hasBounced) {
          if (withoutDelay) {
            this.localStartBounce = 0;
          }
          setTimeout(() => {
            this.changeBounce(true);
            setTimeout(() => {
              this.changeBounce(false);
            }, this.bounce_duration);
          }, this.localStartBounce);
          this.changeHasBounced(true);
        }
        setTimeout(() => {
          this.changeHasBounced(false);
        }, this.bounce_duration);
      },
      refreshInformation() {
        if (!this.info_refreshed) {
          store.http.getChatGroups(this.web, this.groups);
          store.http.getDefaultAnswers(this.web, this.groups);
          store.http.verifyChatAvailability();
          store.websiteService.getUserInfo();
          store.websiteService.getCartInfo();
          this.info_refreshed = true;
        }
      },
      setBounceTimming() {
        this.setBounceDuration(this.bounce_duration);
      },
      handleNewMessage() {
        if (!store.state.hasNewMessages) {
          store.commit('setHasNewMessages', true);
        }
      }
    },
    watch: {
      isChatOpened: function (value) {
        if (value) {
          this.refreshInformation();
        }
      },
      hasNewMessages: function (value) {
        if (value && !this.isChatOpened) {
          this.toggleBounce(true);
        }
      },
      chatWindowStatusType: function(newStatus) {
        store.http.startQueueRefresh(newStatus === 'queue');
      },
    },
    computed: {
      ...mapState(['bounce', 'config', "hasNewMessages", "isChatOpened", "hasBounced", "isBanned"]),
      ...mapGetters(['config', 'chatWindowStatusType']),
      buttonStyles() {
        return {
          '--button-color': this.config.background_color
        };
      },
      config() {
        if(this.$store.state.config){
          return this.$store.state.config;
        }
        let config = {
          background_color: '',
          primary_greeting: '',
          secondary_greeting: '',
          font_type: '',
          font_color: '',
          logo: ''
        }
        return config;
      },
    }
  }
  </script>
  